import { type FormArray, type FormControl, type FormGroup } from '@angular/forms';

import { type ColumnDataType } from '@blaze-shared/api-contracts-domain';

import { type ConnectorConfigurationBase } from '../../__base-connector-dialog/base-connector-dialog.models';
import { type MappingOption } from '../../models/data-connector-dialog';

export interface LoadingState {
  projects?: boolean;
  tables?: boolean;
  connector?: boolean;
}

export interface CalendlyConfiguration extends ConnectorConfigurationBase {
  mappings: CalendlyMapping[];
  personalToken: string;
  projectId: string;
  tableId: string;
}

export interface ConnectorForm {
  connectorName: FormControl<string>;
  personalToken: FormControl<string>;
  projectId: FormControl<string | null>;
  tableId: FormControl<string | null>;
  mappings: FormArray<FormGroup<FormMapping>>;
}

export interface CalendlyMapping {
  sourceName: CalendlyField;
  columnId: string;
}

export interface FormMapping {
  fieldId: FormControl<CalendlyField | null>;
  columnId: FormControl<string | null>;
}

export type CalendlyField =
  | 'startTime'
  | 'endTime'
  | 'name'
  | 'email'
  | 'providerName'
  | 'providerEmail'
  | 'eventId'
  | 'eventType';

export type CompatibleTableTypesForCalendlyField = Record<CalendlyField, ColumnDataType[]>;

export const compatibleMappings: CompatibleTableTypesForCalendlyField = {
  email: ['String', 'Link'],
  endTime: ['DateTime'],
  name: ['String', 'Link'],
  providerEmail: ['String', 'Link'],
  providerName: ['String', 'Link'],
  startTime: ['DateTime'],
  eventId: ['String', 'Link'],
  eventType: ['String', 'Link'],
};

export const baseFieldOptions: MappingOption<CalendlyField>[] = [
  { label: 'Email', value: 'email', columns: [] },
  { label: 'Name', value: 'name', columns: [] },
  { label: 'Start Time', value: 'startTime', columns: [] },
  { label: 'End Time', value: 'endTime', columns: [] },
  { label: 'Provider Email', value: 'providerEmail', columns: [] },
  { label: 'Provider Name', value: 'providerName', columns: [] },
  { label: 'Event ID', value: 'eventId', columns: [] },
  { label: 'Event Type', value: 'eventType', columns: [] },
];
